import { useState } from 'react';

export default function ElectricalFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How much do electricians charge in El Paso?',
      answer: 'Electricians in El Paso typically charge $75-$150 per hour depending on experience, complexity, and time of day. Simple jobs like outlet installation may cost $100-$200, while panel upgrades range from $1,500-$3,500. Emergency after-hours service usually costs 1.5-2x the regular rate. Most electricians provide free estimates for larger projects. Always get multiple quotes and ensure the electrician is licensed and insured.'
    },
    {
      question: 'Do I need a permit for electrical work in El Paso?',
      answer: 'Yes, most electrical work in El Paso requires a permit from the City of El Paso Building Inspection Department. This includes panel upgrades, new circuits, rewiring, and major installations. Simple repairs like replacing outlets or switches typically don\'t require permits. Licensed electricians usually handle permit applications and inspections. Permits ensure work meets National Electrical Code (NEC) and local safety standards.'
    },
    {
      question: 'How do I know if my electrical panel needs to be upgraded?',
      answer: 'Signs you need a panel upgrade include: frequent circuit breaker trips, flickering lights, burning smell from the panel, rust or corrosion, panel is warm to touch, you have a fuse box instead of breakers, panel is over 25 years old, or you\'re adding major appliances or an addition. Most modern homes need at least 200-amp service. If your panel is 100 amps or less and you\'re experiencing issues, an upgrade is likely needed.'
    },
    {
      question: 'What should I do in an electrical emergency?',
      answer: 'In an electrical emergency: 1) If there\'s fire or smoke, evacuate immediately and call 911. 2) For sparking outlets or burning smells, turn off power at the main breaker if safe to do so. 3) Never touch electrical equipment with wet hands or while standing in water. 4) Call a 24/7 emergency electrician. 5) Don\'t attempt DIY repairs on emergency situations. Many El Paso electricians offer 24/7 emergency service for urgent electrical hazards.'
    },
    {
      question: 'How long does it take to rewire a house?',
      answer: 'Rewiring a house in El Paso typically takes 3-10 days depending on home size and complexity. A small 1,000 sq ft home might take 3-5 days, while a larger 2,500+ sq ft home could take 7-10 days. Factors affecting timeline include: accessibility of existing wiring, whether walls need to be opened, number of circuits needed, and inspection scheduling. Most electricians try to minimize disruption by working room-by-room.'
    },
    {
      question: 'Can I do my own electrical work in El Paso?',
      answer: 'Texas law allows homeowners to perform electrical work on their own primary residence, but it must still meet code requirements and pass inspection. However, this is not recommended unless you have proper training. Improper electrical work can cause fires, electrocution, insurance claim denials, and problems selling your home. For safety and code compliance, it\'s best to hire a licensed electrician for anything beyond simple tasks like changing light bulbs.'
    },
    {
      question: 'What is the difference between 100-amp and 200-amp service?',
      answer: 'Amp service refers to the maximum electrical current your home can handle. 100-amp service (older standard) provides about 24,000 watts, suitable for smaller homes with basic appliances. 200-amp service (modern standard) provides 48,000 watts, necessary for homes with central AC, electric heating, multiple large appliances, EV chargers, or home additions. Most new homes and renovations in El Paso require 200-amp service to meet modern electrical demands.'
    },
    {
      question: 'How often should I have my electrical system inspected?',
      answer: 'Electrical systems should be professionally inspected every 3-5 years for homes under 25 years old, and annually for older homes. You should also get an inspection when: buying or selling a home, after major storms, if you notice flickering lights or frequent breaker trips, before major renovations, or if your home has aluminum wiring or a fuse box. Regular inspections identify potential hazards before they become dangerous or costly problems.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about electrical services in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-orange-500 flex-shrink-0`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
